<div class="error-container" [@errorAnimation]="animationState">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-5 -5 67 67" class="error-mark">
    <circle class="error-mark__circle" cx="26" cy="26" r="25" fill="none" />
    <path class="error-mark__line1" fill="none" d="M16 16 36 36" />
    <path class="error-mark__line2" fill="none" d="M36 16 16 36" />
  </svg>
</div>
